import { render, staticRenderFns } from "./myForm.vue?vue&type=template&id=6b5dfe5c&scoped=true"
import script from "./myForm.vue?vue&type=script&lang=js"
export * from "./myForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_babel-core@6.26.3_cache-loader@4.1.0_css-loader@3.6_es6nbxkbffq4rffv33bwkugdri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5dfe5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\bluetooth-light-web\\node_modules\\.pnpm\\registry.npmmirror.com+vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b5dfe5c')) {
      api.createRecord('6b5dfe5c', component.options)
    } else {
      api.reload('6b5dfe5c', component.options)
    }
    module.hot.accept("./myForm.vue?vue&type=template&id=6b5dfe5c&scoped=true", function () {
      api.rerender('6b5dfe5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/business/Form/myForm.vue"
export default component.exports